import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(14, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  '& .TSBackground': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  '& .TSGradient': {
    background: `linear-gradient(180deg, rgba(0, 0, 0, 0.65) 0%,rgba(0, 0, 0, 0.65) 100%)`,
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
  },

  '& .TSContent': {
    position: 'relative',
    zIndex: 2,
  },
  '& .TSBox': {
    display: 'flex',
    padding: theme.spacing(4, 3),
    flexDirection: 'column',
    borderRadius: theme.spacing(1),
    background: theme.palette.background.primary,
    height: '100%',
  },
  '& .TSUserComment': {
    flex: 1,
  },
  '& .TSFooter': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  '& .TSAvatar': {
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontSize: theme.spacing(2.25),
    paddingTop: theme.spacing(0.75),
  },
  '& .TSUserInfo': {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  '& .TSUserName': {
    position: 'relative',
    top: theme.spacing(0.25),
  },
  '& .TSIcon':{
    color: theme.palette.grey.concrete,
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}));

export default StyledBox;
